import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Observable, Subject } from 'rxjs';
import { Site } from '../../shared/interface/site';
import { WidgetService } from '../../shared/services/widget/widget.service';
import { KpiGroups } from '../../shared/interface/kpi-groups';
import { BrandService, CommonService } from '../../shared/services';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'layout-chart-dialog',
    templateUrl: './layout-chart-dialog.html',
    styleUrls: ['./layout-chart-dialog.scss'],
})
export class layoutChartDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll  : Subject<any> = new Subject<any>();
    layoutForm: FormGroup;
    siteList$: Observable<Site[]>;
    kpiGroupList$: Observable<KpiGroups[]>;
    submitted = false;
    kpiList = [];
    kpiElementList = [];
    zoneList = [];

    boxColor: string[] = ["#ffffff", "#000000", "#000000", "#ffffff", "#000", "#ffffff", "#000", "#059505", "#bdbd05", "#d18904"];
    isSubmitted: number = 0;

    widget: any = {};
    dataFilter = [];
    selectValue;
    constructor(private fb: FormBuilder,
        private widgetService: WidgetService, private brandService: BrandService, private commonService: CommonService,
        public dialogRef: MatDialogRef<layoutChartDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.siteList$ = this.widgetService.siteList().pipe(takeUntil(this._unsubscribeAll));
        this.kpiGroupList$ = this.widgetService.kpiGroupList().pipe(takeUntil(this._unsubscribeAll));

        this.widget = { ...this.data.widgetData };
        this.selectValue = this.getDataFilter(this.widget, this.data.id);
        this.selectValue = this.setFormValue(this.selectValue);
        this.createForm(this.selectValue);
        
        
    }

    ngOnInit(): void {
        this.layoutForm.get('kpiGroupId').valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((type: string) => {
            this.layoutForm.get('kpiId').patchValue("");
            this.layoutForm.get('elementId').patchValue("");
        })
        // this.layoutForm.get('kpiId').valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((type: string) => {
        //     this.layoutForm.get('elementId').patchValue("");
        // })
    }

    ngOnDestroy(){
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
      

    loadKpiList(kpiGrpoupId: string) {
        this.kpiList = [];
        this.layoutForm.get('kpiId').clearValidators();
        this.widgetService.kpiList(kpiGrpoupId).pipe(takeUntil(this._unsubscribeAll)).subscribe(
            r => {
                r.forEach(v => {
                    if (v.kpiType && v.kpiType.includes('visual')) {
                        this.kpiList.push(v);
                    }
                });
                if (this.kpiList.length > 0) {
                    this.loadElementList(this.layoutForm.value.kpiId)
                    this.layoutForm.get('kpiId').setValidators([Validators.required]);
                }
                this.layoutForm.get('kpiId').updateValueAndValidity();
            },
            err => { }
        );
    }

    loadElementList(kpiListId: string) {
        this.kpiElementList = [];
        this.layoutForm.get('elementId').clearValidators();
        let kpiList = this.kpiList.filter(item => item._id === kpiListId);
        if (kpiList.length > 0 &&  kpiList[0].elements && kpiList[0].elements.constructor == Array) {
            kpiList[0].elements.forEach((v, i) => {
                if (v.value || v.value == 0) {
                    this.kpiElementList.push(v);
                }
                if (this.kpiElementList.length > 0) {
                    this.layoutForm.get('elementId').setValidators([Validators.required]);
                }
            });
        }else{
            this.layoutForm.get('elementId').patchValue("");
        }
        this.layoutForm.get('elementId').updateValueAndValidity();
    }

    getZoneList(mappedFullSite) {
        // if (mappedFullSite == 0) {
            this.brandService.zoneList("", "").pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
                this.zoneList = res;
                this.zoneList = this.zoneList.filter(z => z.zoneName != "Master Zone");
                let fullSites = ['full'];
                this.zoneList.forEach((v, i) => {
                    fullSites.push(v._id);
                });
                if (this.layoutForm.value.mapped.zones.length == 0 || this.layoutForm.value.mapped.zones.includes('full')) {
                    this.layoutForm.controls['mapped'].patchValue({
                        zones: fullSites
                    });
                }

            });
        // }
    }


    createForm(data) {
        this.layoutForm = this.fb.group({
            kpiGroupId: [data.dataFilter.kpiGroupId, Validators.required],
            kpiNumberFormat: [data.dataFilter.kpiNumberFormat, Validators.required],
            kpiId: [data.dataFilter.kpiId],
            elementId: [data.dataFilter.elementId],
            label: [data.dataFilter.label, Validators.required],
            isThousandSeperator: [data.dataFilter.isThousandSeperator],
            color: [data.dataFilter.color],
            mapped: this.fb.group({
                siteId: data.dataFilter.mapped.siteId ? data.dataFilter.mapped.siteId : "",
                mappedFullSite: data.dataFilter.mapped.mappedFullSite ? data.dataFilter.mapped.mappedFullSite : 0,
                zones: data.dataFilter.mapped.zones ? [data.dataFilter.mapped.zones] : [],
                // devices: data.dataFilter.mapped.devices ? data.dataFilter.mapped.devices : "",
                // brands: data.dataFilter.mapped.brands ? data.dataFilter.mapped.brands : "",
            }),
            backGroundColor: [data.dataFilter.backGroundColor, Validators.required],
            borderColor: [data.dataFilter.borderColor, Validators.required],
            pointerColor: [data.dataFilter.pointerColor, Validators.required],
            labelColor: [data.dataFilter.labelColor, Validators.required],
            tooltipPosition: [data.dataFilter.tooltipPosition, Validators.required],
            transparency: [data.dataFilter.transparency, [Validators.required,Validators.min(0.1),Validators.max(1),Validators.pattern(/^-?\d*[.,]?\d{0,2}$/)]],
            pageX: data.dataFilter.pageX,
            pageY: data.dataFilter.pageY,
            id: data.dataFilter.id
        })
        if (data.dataFilter.kpiGroupId)
            this.loadKpiList(data.dataFilter.kpiGroupId)
        this.getZoneList(this.layoutForm.value.mapped.mappedFullSite);

    }

    setFormValue(data: any) {
        return {
            dataFilter: {
                kpiGroupId: (data && data.kpiGroupId) ? data.kpiGroupId : "",
                kpiNumberFormat: ((data && data.kpiNumberFormat) || (data && data.kpiNumberFormat == 0)) ? data.kpiNumberFormat : -1,
                kpiId: (data && data.kpiId) ? data.kpiId : "",
                elementId: (data && data.elementId) ? data.elementId : "",
                label: (data && data.label) ? data.label : "",
                isThousandSeperator: (data && data.isThousandSeperator) ? data.isThousandSeperator : false,
                color: (data && data.color) ? data.color : "",
                mapped: {
                    siteId: (data && data.mapped && data.mapped[0] && data.mapped[0].siteId) ? data.mapped[0].siteId : "",
                    mappedFullSite: (data && data.mapped && data.mapped[0] && data.mapped[0].mappedFullSite == 0) ? data.mapped[0].mappedFullSite : 1,
                    zones: (data && data.mapped && data.mapped[0] && data.mapped[0].zones) ? data.mapped[0].zones : [],
                    // devices: (data && data.mapped && data.mapped[0] && data.mapped[0].devices) ? data.mapped[0].devices : "",
                    // brands: (data && data.mapped && data.mapped[0] && data.mapped[0].brands) ? data.mapped[0].brands : ""
                },
                backGroundColor: (data && data.backGroundColor) ? data.backGroundColor : "",
                borderColor: (data && data.borderColor) ? data.borderColor : "",
                pointerColor: (data && data.pointerColor) ? data.pointerColor : "",
                labelColor: (data && data.labelColor) ? data.labelColor : "",
                tooltipPosition: (data && data.tooltipPosition) ? data.tooltipPosition : "top",
                transparency: (data && data.transparency) ? data.transparency : 1,
                pageX: (data && data.pageX) ? data.pageX : this.data.pageX,
                pageY: (data && data.pageY) ? data.pageY : this.data.pageY,
                id: (data && data.id) ? data.id : this.data.id
            }
        };
    }

    getDataFilter(widget, id) {
        this.dataFilter = [...widget.dataFilter];
        let selectValue = this.dataFilter.find((i) => {
            return i.id == id
        });
        return selectValue ? selectValue : {}
    }

    onSubmit(form: any) {
        if (!this.layoutForm.valid) {
            return false;
        }
        this.isSubmitted = 1;


        let mapped = form.mapped;
        form.mapped = [{}];
        form.color = !form.color ? this.boxColor[0] : form.color;
        mapped.devices = [];
        form.mapped[0] = mapped;
        form.actual = false;
        form.predictive = false;

        // if (form.mapped.mappedFullSite == 1) {
        //     form.mapped.siteId = "";
        // }
        if (form.mapped[0].mappedFullSite == 1) {
            form.mapped[0].zones = [];
        }

        if (this.data.isCreate)
            this.dataFilter.push(form);
        else {
            let editeFilter = this.dataFilter.map((i) => {
                return i.id == this.data.id ? form : i
            })
            this.dataFilter = [...editeFilter]
        }

        this.widget.dataFilter = [...this.dataFilter];



        //ripun
        this.widget.widgetId = this.widget._id;
        this.widgetService.update(this.widget).pipe(takeUntil(this._unsubscribeAll)).subscribe(
            res => {
                this.dialogRef.close();
                this.widgetService.sendAction("updateWidget", { groupId: this.widget.groupId, widgetId: this.widget._id });
                this.isSubmitted = 0;
            },
            err => {
                this.isSubmitted = 0;
            }
        );
    }

    onDelete(e :any, isDelete: boolean) {
        e.preventDefault()
        e.stopImmediatePropagation()
        if (!isDelete) {
            return false;
        }
        this.isSubmitted = 1;

        if (isDelete) {
            let editeFilter = this.dataFilter.filter((i) => {
                return i.id != this.data.id
            })
            this.dataFilter = [...editeFilter]
        }
        this.widget.dataFilter = [...this.dataFilter];

        this.widget.widgetId = this.widget._id;
        this.widgetService.update(this.widget).pipe(takeUntil(this._unsubscribeAll)).subscribe(
            res => {
                this.dialogRef.close();
                this.widgetService.sendAction("updateWidget", { groupId: this.widget.groupId, widgetId: this.widget._id });
                this.isSubmitted = 0;
            },
            err => {
                this.isSubmitted = 0;
            }
        );
    }


    checkIsFullZoneSelected(zones) {
        if (zones.includes('full')) {
            zones = zones.filter(site => site !== 'full');
            if (zones.length != this.zoneList.length) {
                this.layoutForm.controls['mapped'].patchValue({
                    zones: zones
                });
            }
        } else {
            if (zones.length == this.zoneList.length) {
                zones.push('full');
                this.layoutForm.controls['mapped'].patchValue({
                    zones: zones
                });
            }
        }
    }

    toggleZoneCheckBox(zones) {
        if (zones.includes('full')) {
            this.layoutForm.controls['mapped'].patchValue({
                zones: ['full']
            })
        } else {
            let fullZones = ['full'];
            this.zoneList.forEach((v, i) => {
                fullZones.push(v._id);
            });
            this.layoutForm.controls['mapped'].patchValue({
                zones: fullZones
            })
        }
    }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/private-dashboard/layout-chart-dialog/layout-chart-dialog.ts